import { environment } from 'src/environments/environment'

export const baseUrl = environment.production ? 'https://api.shoppingcart.com' : 'http://localhost:4000';
export const productUrl = baseUrl + '/products'
export const cartUrl = baseUrl + '/cart'
export const wishlistUrl = baseUrl + '/wishlist' 
export const wishlistitemUrl = baseUrl + '/wishlistitem'
export const purseUrl = baseUrl + '/purses'
